import { useGLTF } from "@react-three/drei";
import React from 'react'

export default function WorldScaleRef(props) {
    const gltf = useGLTF(props.modelRef);
    const positionX = props.modelSize/2 + 0.35
  return (
    <primitive position={[positionX,0.01,0]} object={gltf.scene} />
  )
}
